/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";

/**
 * The TransformerOptions component
 *
 * @author Thais Watanabe
 */
const TransformerOptions = (props) => {
  const {
    child,
    position,
    setChildrenResults,
    editedChildResults,
    selectedOption,
  } = props;

  /**
   * hasErrorsChildForm
   * @param {*} position
   */
  function hasErrorsChildForm(position) {
    if (!editedChildResults) {
      return false;
    }

    if (selectedOption !== "不要") {
      if (!editedChildResults[position]) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  /**
   * formatLocal
   * @param {*} value 
   * @param {*} position 
   * @returns 
   */
  function formatLocal(value, position) {
    return value + "," + editedChildResults[position].split(",")[1];
  }

  /**
   * formatNumber
   * @param {*} value 
   * @param {*} position 
   * @returns 
   */
  function formatNumber(value, position) {
    return editedChildResults[position].split(",")[0] + "," + value;
  }

  return (
    <div position={position} className="flex justify-between gap-4 mb-3">
      <div className="w-full">
        <label
          htmlFor={child.id}
          className="block text-sm font-medium text-gray-900"
        >
          フィン区分
        </label>
        <div className="mt-1 relative">
          <select
            autoComplete={child.id}
            id={child.id}
            name={child.id}
            className="block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-teal-500 focus:border-teal-500 sm:text-sm"
            value={
              editedChildResults
                ? editedChildResults[position].split(",")[0]
                : ""
            }
            onChange={(e) =>
              setChildrenResults(
                position,
                formatLocal(e.currentTarget.value, position)
              )
            }
          >
            <option>上部天板</option>
            <option>上手前</option>
            <option>上奥</option>
            <option>中央手前</option>
            <option>下手前</option>
            <option>下奥</option>
          </select>
        </div>
        {hasErrorsChildForm(position) && (
          <p className="mt-2 text-sm text-red-600" id={"error" + child.id}>
            「{child.title} {child.description}
            」を入力してください
          </p>
        )}
      </div>
      <div className="w-full">
        <label
          htmlFor={child.id}
          className="block text-sm font-medium text-gray-900"
        >
          漏れフィン番号
        </label>
        <div className="mt-1 relative">
          <input
            type="text"
            id={child.id}
            name={child.id}
            className={`${
              hasErrorsChildForm(position)
                ? "pr-10 border-red-300 text-red-900 placeholder-red-300 focus:outline-none focus:ring-red-500 focus:border-red-50"
                : "focus:ring-teal-500 focus:border-teal-500 border-gray-300"
            } block w-full shadow-sm sm:text-sm rounded-md`}
            value={
              editedChildResults
                ? editedChildResults[position].split(",")[1]
                : ""
            }
            onChange={(e) =>
              setChildrenResults(
                position,
                formatNumber(e.target.value, position)
              )
            }
          />
        </div>
        {hasErrorsChildForm(position) && (
          <p className="mt-2 text-sm text-red-600" id={"error" + child.id}>
            「{child.title} {child.description}
            」を入力してください
          </p>
        )}
      </div>
    </div>
  );
};

export default TransformerOptions;
